import { apiFetch } from './api.js'

const BASE = (import.meta.env.VITE_API_BASE ?? '') + '/report'

/** Every timed household event from `back` hours ago to `ahead` hours from now. */
export async function fetchReportTimeline({ back = 48, ahead = 48 } = {}) {
  const r = await apiFetch(`${BASE}/timeline?back=${back}&ahead=${ahead}`)
  if (!r.ok) throw new Error(`report ${r.status}`)
  return r.json()
}

/** Live energy flow: sources → house → consumers, garden 3EM phases. */
export async function fetchEnergyFlow() {
  const r = await apiFetch(`${BASE}/flow`)
  if (!r.ok) throw new Error(`report flow ${r.status}`)
  return r.json()
}

/** Every formula with its worked examples, run against the server's real code. */
export async function fetchFormulas() {
  const r = await apiFetch(`${BASE}/formulas`)
  if (!r.ok) throw new Error(`report formulas ${r.status}`)
  return r.json()
}

/** The calculator: one formula with the viewer's own inputs → { result } or { error }. */
export async function evaluateFormula(id, inputs) {
  const r = await apiFetch(`${BASE}/formulas/${encodeURIComponent(id)}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ inputs }),
  })
  if (!r.ok) throw new Error(`formula ${r.status}`)
  return r.json()
}

/** Every calendar year side by side: house, devices, what the cheap night window brings. */
export async function fetchYearReport({ period }) {
  const r = await apiFetch(`${BASE}/years?period=${encodeURIComponent(period ?? 'ytd')}`)
  if (!r.ok) throw new Error(`report years ${r.status}`)
  return r.json()
}
